/**
 * Shared markdown renderer for help-assistant assistant bubbles (AB#26561). A single configured
 * `markdown-it` instance so every caller renders with the same (safe) settings rather than each
 * `.vue` file constructing its own.
 *
 * Deliberately the library default config: `html: false` (raw HTML in the source markdown is
 * escaped, not passed through) is the safe default against an assistant answer that happens to
 * contain something that looks like a tag - see docs/work/AB26561-chat-docs-help-poc/ for the
 * wire contract. Do NOT flip `html` on.
 */
import MarkdownIt from 'markdown-it'

const md = new MarkdownIt()

/**
 * Renders a markdown string to HTML for use with `v-html`. Never throws: an undefined/null
 * input renders as an empty string rather than crashing the message list.
 * @param {string} text
 * @returns {string}
 */
export function renderMarkdown (text) {
	return md.render(text || '')
}
